var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorthEastIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82419 0.699109C5.82419 0.857815 5.88724 1.01002 5.99946 1.12224C6.11168 1.23446 6.26389 1.29751 6.42259 1.29751H10.3182L0.354827 11.2608C0.256793 11.3753 0.205567 11.5226 0.211384 11.6732C0.217201 11.8238 0.279633 11.9666 0.386205 12.0732C0.492776 12.1798 0.635638 12.2422 0.78624 12.248C0.936843 12.2539 1.08409 12.2026 1.19857 12.1046L11.1499 2.15322V6.01888C11.1499 6.17758 11.213 6.32979 11.3252 6.44201C11.4374 6.55423 11.5896 6.61727 11.7483 6.61727C11.907 6.61727 12.0593 6.55423 12.1715 6.44201C12.2837 6.32979 12.3467 6.17758 12.3467 6.01888V0.633285C12.3467 0.490451 12.29 0.353466 12.189 0.252467C12.088 0.151467 11.951 0.0947266 11.8082 0.0947266H6.42259C6.3435 0.0947226 6.2652 0.110397 6.1922 0.140842C6.11921 0.171288 6.05298 0.215902 5.99733 0.272104C5.94168 0.328306 5.89773 0.394981 5.86801 0.468274C5.8383 0.541567 5.8234 0.620024 5.82419 0.699109Z",
    fill: "#FF5F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthEastIcon);
export default __webpack_public_path__ + "static/media/NorthEast_icon.3a9f9fb1cece414ae2ac65238cf48369.svg";
export { ForwardRef as ReactComponent };